import { GET, KVP, POST, PUT } from "../utils/api";
import { Status, UserLevel } from "../models";

export async function signIn(payload: KVP) {
  return POST({
    path: "/user/login",
    body: payload,
  });
}

export async function getUserInfo() {
  return GET({
    path: `/myInfo`,
  });
}

export async function getUsersInOrg(orgId: number, level?: UserLevel) {
  return GET({
    path: `/org/${orgId}/userlist`,
    params: {
      level,
    },
  });
}

export interface RegisterUser {
  userName: string;
  firstName: string;
  lastName: string;
  description: string;
  orgType: number;
  level: number;
  password: string;
  // 注意这是organizationID
  organization: number;
}

export async function registerUser(user: RegisterUser) {
  return POST({ path: `/user`, body: user });
}

export interface UpdateBasicUser {
  id: number;
  firstName: string;
  lastName: string;
  description: string;
}

export async function updateUser(user: UpdateBasicUser) {
  return PUT({ path: `/user/${user.id}/basic`, body: user });
}

export async function changeUserStatus(userId: number, payload: { userStatus: Status }) {
  return PUT({ path: `/user/${userId}/status`, body: payload });
}

export async function resetPwd(userId: number) {
  return PUT({ path: `/user/${userId}/passwordReset` });
}

export interface ChangePasswordReq {
  originPwd: string;
  newPwd: string;
}

export async function changePwd(payload: ChangePasswordReq) {
  return PUT({ path: `/myPwd`, body: payload });
}
